import React, { useEffect, useState } from "react";
import "../Fullscreen/FullpageLoader.css";
import CircularProgress from "@mui/material/CircularProgress";

import { images } from "../config/images";
import { Box } from "@mui/system";

const FullpageLoader = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="loader-container">
      <Box sx={{ display: "flex" }}>
        <CircularProgress />
      </Box>
    </div>
  );
};

export default FullpageLoader;
